module.exports = __webpack_public_path__ + "img/active_icon03.123c315a.png";